var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-auditoria-contratos-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listadoAuditoriaContratos,"items-per-page":20},scopedSlots:_vm._u([{key:"item.meta",fn:function(ref){
var item = ref.item;
return [_c('cortar-texto',{attrs:{"texto":item.objeto}})]}},{key:"item.contratista",fn:function(ref){
var item = ref.item;
return [_vm._v("\n     "+_vm._s(item.contratista? item.contratista : '')+"\n    ")]}},{key:"item.numero",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(item.numero))])]}},{key:"item.ultimaEstimacionAuditada",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"font-weight-light"},[_vm._v(_vm._s(item.ultimaEstimacionAuditada))])]}},{key:"item.porcentajeAvanceAuditado",fn:function(ref){
var item = ref.item;
return [(item.porcentajeAvanceAuditado!==null)?_c('span',{staticClass:"font-weight-light"},[_vm._v("\n        "+_vm._s(item.porcentajeAvanceAuditado)+"%\n       ")]):_vm._e()]}},{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"auditoriaContratos":item}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }